






import { Component, Vue } from 'vue-property-decorator';
import { Mutations } from '@/ts/store/Constants';

@Component
export default class StaffBackButton extends Vue {
    constructor() {
        super();
    }

    public goBack() {
        if (this.$store.getters['StaffProperties/getStaffChatBackLink']) {
            this.$store.commit(Mutations.SET_STAFF_CHAT_BACK_LINK, false);
            this.$router.push({name: 'inbox'});
        } else {
            this.$router.go(-1);
        }
    }
}
